export const SET_USED_ZPOS = 'ZPOS/SET_USED_ZPOS';
export const SET_ZPOS_CONFIGURATED = 'ZPOS/SET_ZPOS_CONFIGURATED';
export const SET_ZPOS_INTEGRATOR_COLLECTION = 'ZPOS/SET_ZPOS_INTEGRATOR_COLLECTION';
